import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import ThemeToggle from '../UI/ThemeToggle';
import './Layout.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  const closeMenu = () => {
    setMenuOpen(false);
  };
  
  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/" className="logo-link">
            <h1>Calculadora de Juros Compostos</h1>
          </Link>
        </div>
        
        <button 
          className={`menu-toggle ${menuOpen ? 'open' : ''}`} 
          onClick={toggleMenu}
          aria-expanded={menuOpen}
          aria-label="Menu de navegação"
        >
          <span className="hamburger"></span>
        </button>
        
        <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink 
                to="/" 
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={closeMenu}
                end
              >
                Calculadora
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/guia" 
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={closeMenu}
              >
                Guia
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink 
                to="/sobre" 
                className={({ isActive }) => isActive ? 'active' : ''}
                onClick={closeMenu}
              >
                Sobre
              </NavLink>
            </li>
            <li className="nav-item theme-toggle-item">
              <ThemeToggle />
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;